// HGS — Organisational Hierarchy
// Operating Head → multiple Divisional Heads → multiple Department Heads
// This is the single source of truth for the org tree. DEPARTMENTS, DEMO_USERS
// and all RBAC filtering derive from this structure.

export const ORG_TREE = {
  'hr-admin': {
    id: 'hr-admin',
    label: 'HR & Admin',
    color: '#EC4899',
    head: { name: 'Suresh Iyer', email: 'oh.hradmin@hmsi.com', avatar: 'SI' },
    divisions: {
      'human-resource': {
        id: 'human-resource',
        label: 'Human Resource',
        head: { name: 'Meera Reddy', email: 'div.hr@hmsi.com', avatar: 'MR' },
        departments: {
          'learning-engagement':  { id: 'learning-engagement',  label: 'Learning & Engagement',  head: { name: 'Amit Sharma',  email: 'le.head@hmsi.com',  avatar: 'AS' } },
          'associate-lifecycle':  { id: 'associate-lifecycle',  label: 'Associate Lifecycle',    head: { name: 'Nisha Pillai', email: 'al.head@hmsi.com',  avatar: 'NP' } },
          'talent-acquisition':   { id: 'talent-acquisition',   label: 'Talent Acquisition',     head: { name: 'Kavita Nair',  email: 'ta.head@hmsi.com',  avatar: 'KN' } },
          'development':          { id: 'development',          label: 'Development',            head: { name: 'Rohit Sinha',  email: 'dev.head@hmsi.com', avatar: 'RS' } },
          'strategy-planning':    { id: 'strategy-planning',    label: 'Strategy & Planning',    head: { name: 'Ananya Bose',  email: 'sp.head@hmsi.com',  avatar: 'AB' } },
        },
      },
      'industrial-relations': {
        id: 'industrial-relations',
        label: 'Industrial Relations',
        head: { name: 'Ravi Menon', email: 'div.ir@hmsi.com', avatar: 'RM' },
        departments: {
          'ir-planning':          { id: 'ir-planning',         label: 'IR Planning & Strategy',     head: { name: 'Sanjay Patel',   email: 'irp.head@hmsi.com', avatar: 'SP' } },
          'working-conditions':   { id: 'working-conditions',  label: 'Working Condition Mgmt',     head: { name: 'Priti Kulkarni', email: 'wc.head@hmsi.com',  avatar: 'PK' } },
          'payroll-time-office':  { id: 'payroll-time-office', label: 'Payroll & Time Office Mgmt', head: { name: 'Mohan Das',      email: 'pto.head@hmsi.com', avatar: 'MD' } },
          'union-welfare':        { id: 'union-welfare',       label: 'Union Welfare & Compliance', head: { name: 'Lakshmi Rao',    email: 'uw.head@hmsi.com',  avatar: 'LR' } },
        },
      },
      'admin-security': {
        id: 'admin-security',
        label: 'Administration & Security',
        head: { name: 'Vikram Joshi', email: 'div.admin@hmsi.com', avatar: 'VJ' },
        departments: {
          'admin':               { id: 'admin',              label: 'Admin',                head: { name: 'Ramesh Joshi', email: 'admin.head@hmsi.com',   avatar: 'RJ' } },
          'vigilance-security':  { id: 'vigilance-security', label: 'Vigilance & Security', head: { name: 'Inder Singh',  email: 'vs.head@hmsi.com',      avatar: 'IS' } },
          'fleet-hotel':         { id: 'fleet-hotel',        label: 'Fleet & Hotel Mgmt',   head: { name: 'Pavan Kumar',  email: 'fh.head@hmsi.com',      avatar: 'PaK' } },
          'project-upkeep':      { id: 'project-upkeep',     label: 'Project & Upkeep',     head: { name: 'Nidhi Verma',  email: 'pu.head@hmsi.com',      avatar: 'NV' } },
        },
      },
    },
  },

  'manufacturing': {
    id: 'manufacturing',
    label: 'Manufacturing',
    color: '#10B981',
    head: { name: 'Priya Verma', email: 'oh.manufacturing@hmsi.com', avatar: 'PV' },
    divisions: {
      'production-ops': {
        id: 'production-ops',
        label: 'Production Operations',
        head: { name: 'Karan Malhotra', email: 'div.production@hmsi.com', avatar: 'KM' },
        departments: {
          'plant-ops':            { id: 'plant-ops',            label: 'Plant Operations',     head: { name: 'Deepak Rao',  email: 'po.head@hmsi.com', avatar: 'DR' } },
          'maintenance':          { id: 'maintenance',          label: 'Maintenance',          head: { name: 'Suresh Yadav', email: 'mn.head@hmsi.com', avatar: 'SY' } },
          'production-planning':  { id: 'production-planning',  label: 'Production Planning',  head: { name: 'Anita Desai',  email: 'pp.head@hmsi.com', avatar: 'AD' } },
        },
      },
      'quality-engineering': {
        id: 'quality-engineering',
        label: 'Quality & Engineering',
        head: { name: 'Anil Kapoor', email: 'div.quality@hmsi.com', avatar: 'AK' },
        departments: {
          'quality-assurance':    { id: 'quality-assurance', label: 'Quality Assurance',     head: { name: 'Vikram Iyer',     email: 'qa.head@hmsi.com', avatar: 'VI' } },
          'r-and-d':              { id: 'r-and-d',           label: 'R&D / Engineering',     head: { name: 'Geeta Krishnan',  email: 'rd.head@hmsi.com', avatar: 'GK' } },
          'testing-validation':   { id: 'testing-validation', label: 'Testing & Validation', head: { name: 'Suman Khan',      email: 'tv.head@hmsi.com', avatar: 'SuK' } },
        },
      },
      'supply-chain': {
        id: 'supply-chain',
        label: 'Supply Chain',
        head: { name: 'Rajesh Kumar', email: 'div.supply@hmsi.com', avatar: 'RK' },
        departments: {
          'procurement':          { id: 'procurement',     label: 'Procurement',         head: { name: 'Arjun Mehta',   email: 'proc.head@hmsi.com', avatar: 'AM' } },
          'finance-costing':      { id: 'finance-costing', label: 'Finance & Costing',   head: { name: 'Sneha Kapoor',  email: 'fc.head@hmsi.com',   avatar: 'SK' } },
          'logistics':            { id: 'logistics',       label: 'Logistics',           head: { name: 'Manoj Bhat',    email: 'log.head@hmsi.com',  avatar: 'MB' } },
        },
      },
    },
  },
};

// ------------------------------------------------------------------
// Helpers (single source of truth — derive everything from ORG_TREE)
// ------------------------------------------------------------------

/** Iterate every dept in tree-order. Returns array of { ohId, ohLabel, divId, divLabel, deptId, deptLabel, deptHead } */
export function listDepartments() {
  const out = [];
  Object.values(ORG_TREE).forEach((oh) => {
    Object.values(oh.divisions).forEach((div) => {
      Object.values(div.departments).forEach((dept) => {
        out.push({
          ohId: oh.id,
          ohLabel: oh.label,
          divId: div.id,
          divLabel: div.label,
          deptId: dept.id,
          deptLabel: dept.label,
          deptHead: dept.head,
          color: oh.color,
        });
      });
    });
  });
  return out;
}

/** All divisions, with their parent OH context */
export function listDivisions() {
  const out = [];
  Object.values(ORG_TREE).forEach((oh) => {
    Object.values(oh.divisions).forEach((div) => {
      out.push({
        ohId: oh.id, ohLabel: oh.label,
        divId: div.id, divLabel: div.label,
        head: div.head,
        deptCount: Object.keys(div.departments).length,
      });
    });
  });
  return out;
}

/** Lookup the full path (ohId, divId) for a given dept id. Memoised lazily. */
let _deptIndex = null;
function deptIndex() {
  if (_deptIndex) return _deptIndex;
  _deptIndex = {};
  listDepartments().forEach((d) => { _deptIndex[d.deptId] = d; });
  return _deptIndex;
}

/** Given a department id (e.g. "procurement"), return { ohId, divId } so risk rows
 *  tagged with assignedDepartment can be filtered by hierarchy. */
export function lineageForDept(deptId) {
  if (!deptId) return null;
  return deptIndex()[deptId] || null;
}

/** Mapping from legacy 6-dept ids → new department ids in the hierarchy.
 *  Used only by riskUniverse / master sample rows that still reference old ids. */
export const LEGACY_DEPT_MAP = {
  procurement: 'procurement',
  finance: 'finance-costing',
  quality: 'quality-assurance',
  production: 'plant-ops',
  hr: 'talent-acquisition',
  safety: 'vigilance-security',
};

export function resolveDeptId(idOrLegacy) {
  if (!idOrLegacy) return null;
  return LEGACY_DEPT_MAP[idOrLegacy] || idOrLegacy;
}
